import React from "react";
import "./Styles/Devenirvendeur.css"
import { Header } from "./Header.";
import Footer from "./Footer";
import PageHeader from "./PageHeader";
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";

export const DevenirVendeur = () => {
    const [firstname, setFirstname] = React.useState('')
    const [lastname, setLastname] = React.useState('')
    const [email, setEmail] = React.useState('')
    const [contact, setContact] = React.useState('')
    const [description, setDescription] = React.useState('')
    const [loading, setLoading] = React.useState(false)

    document.title = "Devenir Vendeur - KabaaShop";

    const handleSubmit = () => {

        if(firstname === '' || lastname === '' || email === '' || contact === '' || description === ''){
            toast.error('Vous devez remplir tous les champs du formulaire !')
            return;
        }

        if(description.length < 10){
            toast.error('Dîtes-en plus sur vos activités !')
            return;
        }

        let data = {
            firstname: firstname,
            lastname: lastname,
            email: email,
            contact: contact,
            description: description
        }

        setLoading(true)
        axios.post(process.env.REACT_APP_API_BASE_URL + '/services/email/become-seller',
            JSON.stringify(data), {
            headers: {
                'x-api-token': process.env.REACT_APP_API_TOKEN,
            }
        }).then(a => {
            setLoading(false)

            setFirstname('')
            setLastname('')
            setEmail('')
            setContact('')
            setDescription('')

            toast.success('Votre demande a bien été envoyé. Vous serez contacter bientôt par un agent.')
        }).catch(error => {
            setLoading(false)
            toast.error('Une erreur est survenue');
        })
    }

    return (
        <>
        <ToastContainer/>
            <Header />

            <PageHeader title={"Devenir Vendeur"} />
            
            <form onSubmit={(e)=>{
                e.preventDefault()
                handleSubmit()
            }}>
                <div className="Box-container">
                    <div className="Box-container-name">
                        <Box
                            component="form"
                            sx={{
                                '& > :not(style)': { m: 1, width: '100%', },
                            }}
                            noValidate
                            autoComplete="off"
                        >
                            <TextField disabled={loading} required value={firstname} onChange={(e) => { setFirstname(e.target.value) }} label="Votre Nom" variant="outlined" />
                            <TextField disabled={loading} required value={lastname} onChange={(e) => { setLastname(e.target.value) }} label="Vos Prenoms" variant="outlined" />
                        </Box>
                    </div>
                    <div className="Box-container-mail">
                        <Box
                            component="form"
                            sx={{
                                '& > :not(style)': { m: 1, width: '100%' },
                            }}
                            noValidate
                            autoComplete="off"
                        >
                            <TextField disabled={loading} required type="email" value={email} onChange={(e) => { setEmail(e.target.value) }} label="Votre Adresse Email" variant="outlined" />
                        </Box>
                    </div>
                    <div className="Box-container-tel">
                        <Box
                            component="form"
                            sx={{
                                '& > :not(style)': { m: 1, width: '100%' },
                            }}
                            noValidate
                            autoComplete="off"
                        >

                            <TextField disabled={loading} required value={contact} onChange={(e) => { setContact(e.target.value) }} label="Votre Contact" variant="outlined" />
                        </Box>
                    </div>
                    <div className="Box-container-description">
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '100%' },
                            }}
                            noValidate
                            autoComplete="off"
                        >

                            <TextField
                                disabled={loading}
                                required
                                value={description} onChange={(e) => { setDescription(e.target.value) }}
                                label="Décrivez votre activité, vos services et votre boutique"
                                multiline
                                rows={6}
                            />
                        </Box>
                    </div>
                    <div className="Form-button">
                        <Button disabled={loading} type="submit" variant="contained">Envoyer</Button>
                    </div>
                </div>
            </form>

            <Footer />
        </>
    )
}